const resources = {
    thanksMessage: 'Merci pour vos commentaires!',
    submit: 'Soumettre',
    close: 'close'
};

export default function getResource(label) {
    return resources[label];
}
